import { render, staticRenderFns } from "./ReviewIndex.vue?vue&type=template&id=4f8c0808&scoped=true"
import script from "./ReviewIndex.vue?vue&type=script&lang=js"
export * from "./ReviewIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8c0808",
  null
  
)

export default component.exports